<!-- App.svelte -->
<script>

  import { Router, Route } from "svelte-routing";
  import { locales } from "./libs/i18n";
  import Nav from './components/Nav.svelte'
  import Footer from './components/Footer.svelte'
  import ArrowUp from './components/ArrowUp.svelte'
  //import Page from './components/Page.svelte'

  import Home from "./routes/Home.svelte";
  import Refer2 from "./routes/Refer2.svelte";
  import Term from "./routes/Term.svelte";
  import Privacy from "./routes/Privacy.svelte";
  import Affiliate from "./routes/Affiliate.svelte";
  import YukaEvent from "./routes/YukaEvent.svelte";
  import Event from "./routes/Event.svelte";
  import Event2 from "./routes/Event2.svelte";
  let scrollY;
</script>

<Router>
  <div class="todoapp stack-large">
    <!-- ======= Header ======= -->
    <header id="header" class="fixed-top header-scrolled">
      <div class="container d-flex align-items-center justify-content-between">
        <Nav {locales}/>
      </div>
    </header>
    <div>
      <Route path="/" component={Home} />
      <Route path="/refer2" component={Refer2} />
      <Route path="/term" component={Term} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/affiliate" component={Affiliate} />
      <Route path="/course-yuka" component={YukaEvent} />
      <Route path="/event" component={Event} />
      <Route path="/event2" component={Event2} />
      <Footer />
      {#if scrollY > 100}
        <ArrowUp />
      {/if}
    </div>
  </div>
</Router>
<svelte:window bind:scrollY={scrollY} />